module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/mv_text_frame-7c24e85a9ed1b64435e50e87a80e1d3e.png";